<template>
  <v-app>
    <div class="card ">
      <div class="card-header">
        <div class="card-title pt-3 px-3 d-flex justify-content-between">
          <div class="breadcrumb-left">
            <h4>Racks</h4>
            <div class="breadcrumb-sub-header">
              <router-link to="/dashboard">Dashboard</router-link>
              \   <router-link :to="{ name: 'shelf' }">
              Shelf
            </router-link>
              \
              Racks
            </div>
          </div>
          <div class="breadcrumb-right">
            <div class="card-toolbar">
              <v-btn @click="addNewRack()" class="mt-4 btn btn-primary" style="color: #fff">
                <v-icon small elevation="2" outlined>fas fa-plus</v-icon>&nbsp;
                Add new
              </v-btn>
            </div>
          </div>
        </div>
      </div>
      <div class="card-body">
        <div class="table-responsive">
          <table class="table">
            <thead>
            <tr class="px-3">
              <th>Rack name</th>
              <th>Shelf</th>
              <th>Status</th>
              <th class="pr-3 text-center">Action</th>
            </tr>
            </thead>
            <tbody v-if="racks.length>0">
            <tr v-for="(rack, index)  of racks" :key="index">
              <td>
                <span class="font-weight-black">
                  {{ rack.title }}
                </span>
              </td>
              <td>
                <span class="font-weight-medium">
                   {{ rack.shelf_title }}
                </span>

              </td>
              <td>
                <span class="badge badge-success text-lg`" v-bind:class="{ 'badge-success': rack.is_active, 'badge-danger': !rack.is_active }">
                  {{ rack.is_active ? 'Active' : 'Inactive' }}</span>
              </td>
              <td class="pr-0 text-center">
                <b-dropdown
                    size="sm"
                    variant="link"
                    toggle-class="custom-v-dropdown btn btn-clean btn-hover-light-primary btn-sm btn-icon"
                    no-caret
                    right
                    no-flip
                >
                  <template v-slot:button-content>
                    <slot>
                          <span>
                            <i class="flaticon-more-1"></i>
                          </span>
                    </slot>
                  </template>
                  <!--begin::Navigation-->
                  <div class="navi navi-hover ">
                    <b-dropdown-text tag="div" class="navi-item" v-if="checkIsAccessible('library-shelf-rack', 'edit')">
                      <a href="#" class="navi-link"
                         @click="editRack(rack)">
                                                            <span class="navi-icon">
                                                              <i class="flaticon-edit"></i>
                                                            </span>
                        <span class="navi-text">  Edit</span>
                      </a>
                    </b-dropdown-text>
                    <b-dropdown-text tag="div" class="navi-item" v-if="checkIsAccessible('library-shelf-rack', 'delete')">
                      <a href="#" class="navi-link"
                         @click="deleteRack( rack.id)">
                                                            <span class="navi-icon">
                                                              <i class="fas fa-trash"></i>
                                                            </span>
                        <span class="navi-text">  Delete</span>
                      </a>
                    </b-dropdown-text>

                  </div>
                  <!--end::Navigation-->
                </b-dropdown>
              </td>
            </tr>
            </tbody>
            <tbody v-else>
            <tr>
              <td colspan="4" class="text-center">
                No rack found
              </td>
            </tr>
            </tbody>
          </table>

        </div>
      </div>
    </div>
    <rack-create-and-update :shelfId="shelf_id || null" ref="rack" :dialog="dialog" @close_dialog="getRacks()"></rack-create-and-update>
  </v-app>
</template>
<script>

import RackCreateAndUpdate from "@/view/pages/library/shelf/rack/CreateAndUpdate";
import LibraryShelfRackService from "@/core/services/library/shelf/LibraryShelfRackService";
import dialog from "@/assets/js/components/dialog";

const rackService = new LibraryShelfRackService();

export default {
  name: "Index",
  components: {RackCreateAndUpdate},
  data() {
    return {
      racks: [],
      dialog: false,
      total: null,
      perPage: null,
      page: null,
    }
  },
  mounted() {
    this.getRacks()
  },
  computed: {
    shelf_id() {
      return this.$route.params.id;
    }
  },
  methods: {
    getRacks() {
      this.dialog = false
      if (this.shelf_id != undefined && this.shelf_id != null) {
        rackService.getByShelf(this.shelf_id).then(response => {
          this.racks = response.data.data;

        })
      } else {
        rackService.paginate().then(response => {
          this.racks = response.data.data
        })
      }
    },
    editRack(rack) {
      this.dialog = true
      this.$refs['rack'].editNewRack(rack);
    },
    deleteRack(id) {
      this.$confirm({
        message: `Are you sure?`,
        button: {
          no: "No",
          yes: "Yes"
        },
        callback: confirm => {
          if (confirm) {
            rackService.delete(id).then(response => {
              this.$snotify.success("Rack deleted successfully")
              this.getRacks();
            })
          }
        }
      });
    },
    addNewRack() {
      this.dialog = true;
      this.$refs['rack'].createNewRack();
    }
  }
}
</script>

<style scoped>
</style>
